import React, { Component } from 'react';
import styled from "styled-components";
import { history } from "../../utils";
import { Button } from "../../components";
import { getPracticeTestOverview, getPracticeTestResults } from '../../lib/api';
import Flex from 'styled-flex-component';
import PracticeTestAnalysis from './PracticeTestAnalysis';
import PracticeTestSummary from './PracticeTestSummary';
const LayoutWrapper = styled.div`
    height: 100vh;
    overflow: auto;
    background-color: white;
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
`

const Color = styled.div`
    width:16px;
    height:16px;
    background: ${({ color }) =>
    color ? color : 'white'};
    display:inline-block;
    margin-right:10px;

`


const StyledTable = styled.table`
  margin-top:50px;
  border-collapse: collapse;
  width: 100%;
  tbody tr{
    td, th {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
  }
  
`

function callbackToNative(msg) {
  try {
    if (window.webkit != undefined) {
      window.webkit.messageHandlers.observe.postMessage(msg);
      window.webkit.messageHandlers.appInterface.postMessage(msg)
    }
    if (window.appInterface != undefined) {
      window.appInterface.postMessage(msg)
    }
  } catch (error) {
    console.log(msg);
    console(error);
  }
}

let tabs = ['SUMMARY', 'ANALYTICS']
class PracticeTestOverview extends Component {
  constructor(props) {
    super(props);
    //this.pieChart = React.createRef();
  }

  state = {
    response: null,
    status: '',
    tid: null,
    loading: true,
    activeTab: 'SUMMARY'
  };
  componentDidMount = async () => {
    try {
      let search = this.props.location.search;
      let tid = this.props.match.params.tid;
      if (tid) {
        let response1 = await getPracticeTestResults(tid);
        let response = await getPracticeTestOverview(tid);  
        response.summary = response.topicWise_data.map((item) => {
          let correct = item.correct_questions_count;
          item['correct'] = correct;
          delete item.correct_questions_count;
          return { ...item }
        });
        delete response.topicWise_data;
        var data = {
          series: [response.correct_answered_count, response.unanswered_count, response.wrong_answered_count]
        };
        
        this.setState({
          response: response, questions: response1.questions,
          practice_id: response1.test_id,
          search: search, loading: false, tid: tid, status: response.status, data: data, practiceResultsPath: `/practiceTestResults/${tid}/`});
      } else {
        let initialState = localStorage.getItem('practiceState');
        let practiceTestProps = localStorage.getItem('practiceTestProps');
        let response = localStorage.getItem('practiceTestResponse');
        response = JSON.parse(response);
        if (initialState && practiceTestProps) {
          initialState = JSON.parse(initialState);
          practiceTestProps = JSON.parse(practiceTestProps);
          practiceTestProps.qid = 0;
        }
        console.log(response)
        var data = {
          series: [response.correct_questions_count, response.unanswered_questions_count, response.wrong_answered]
        };
        this.setState({ response: response, loading: false, data: data, ...initialState, ...practiceTestProps, practiceResultsPath: `/practiceTestResults/`});
      }
    } catch (error) {
      console.log(error);
      this.setState({ response: null, loading: false });
    }
  }
  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }


  changeTab = () => {
    let tab = this.state.activeTab;
    if(tab === 'SUMMARY') {
      this.setState({activeTab: 'ANALYTICS'})
    } else {
      this.setState({activeTab: 'SUMMARY'})
    }
  }

  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface)
        return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  doneResults = async () => {
    this.doneHandle();
  };

  doneHandle = () => {

    let bool = this.checkNative();
    if (bool) {
      this.callbackToNative("done");
      console.log('done called');
    } else {
      window.location.href = '/';
      console.log('done called');
    }
  }

  viewResults = (qid) => {
    if (this.state.tid) {
      history.push(`/practiceTestResults/${this.state.tid}/0${this.props.location.search}`);
    } else {
      history.push(`/practiceTestResults/${qid}`);
    }
  }

  render() {
    if (this.state.loading) {
      return <LayoutWrapper>
        <p style={{ textAlign: 'center' }}>Please wait</p>
      </LayoutWrapper>
    }
    let response = this.state.response;
    let data = this.state.data;
    let {questions, answers, practiceResultsPath, search} = this.state
    return <>
      {!response || (response && response.status != 200) ? <LayoutWrapper>
        <h3 style={{ textAlign: 'center' }}>Something went wrong</h3>
        <div style={{ marginTop: '30px', textAlign: 'center' }}>
          <Button small onClick={() => callbackToNative('done')} >Close </Button>
        </div>
      </LayoutWrapper> : <div style={{overflowY: 'scroll', webkitOverflowScrolling: 'scroll'}}>
            <div className='tabs'>
              <div style={{ width: '50px', cursor: 'pointer', color: 'white', marginBottom: '10px' }}>
                <img style={{ color: 'white' }} onClick={this.doneResults} src="/images/back.svg"></img>
              </div>
              <Flex direction="row" justifyCenter alignCenter justifyAround>
                {tabs.map((tab, index) => (
                  <div key={index} className={this.state.activeTab == tab ? 'activeTab' : 'tab'} onClick={() => this.changeTab(tab)} >
                    {tab}
                  </div>
                ))}
              </Flex>  
            </div>
          <LayoutWrapper>
            
            <div className = 'tabsContent'>
              {!this.state.loading && 
                <div>
                  {this.state.activeTab === 'SUMMARY' ? 
                    <PracticeTestSummary response = {response} data= {data} tid={this.state.tid} questions={questions} answers={answers} practiceResultsPath={practiceResultsPath} search={search} viewQuestion={(qid)=>this.viewResults(qid)}></PracticeTestSummary>
                  : <PracticeTestAnalysis response={response} data={data} tid={this.state.tid} questions={questions} answers= {answers}></PracticeTestAnalysis>
                  }
                </div>}
            </div>
          </LayoutWrapper>
          <style jsx='true' scoped>{`
                  .activeTab{
                      padding: 6px 30px;
                      font-size: 14px;
                      font-weight: 600;
                      color: black;
                      border-bottom: 2px solid black;
                      padding-bottom: 5px;
                  }
                  .tab{
                      font-size:14px;
                      padding: 6px 30px;
                      padding-bottom: 5px;
                      font-weight: 600;
                      color: #827e7e;
                  }
                  .tabs{
                      padding:8px;
                      padding-bottom: 0;
                      padding-top: 18px;
                      background-color: white;
                      position: fixed;
                      top: 0;
                      width: 100%;
                      height: auto;
                      z-index: 10;
                      overflow: hidden;
                      scrollbar-width: none;
                      &::-webkit-scrollbar {
                        display: none;
                      }
                  }
                  .tabsContent{
                    padding-top:20px;
                    padding-bottom:100px;
                    margin-top: 70px;
                  }
          `}

          </style>
        </div>}


    </>
  }
}

export default PracticeTestOverview;